module.exports = __webpack_public_path__ + "media/images/teacher-1464dca3f1071920d79b37ff54e04842.jpg";